import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getCotizacionById = async (idCotizacion) => {
        try {
        const response = await mainAxios.get(
            `/v1/cotizacion/id/${idCotizacion}`,
            getDefaultHeaders()
        );

        return response.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
